import React from "react";
import PropTypes from "prop-types";
import {AuditTable} from "./AuditTable";
import {AnnotationType, AuditItemTypeTitle} from "../../Models/Audit/AuditConstants";

export const AuditMapSelectedIssues = ({
    audit,
    tidySelectedIssues,
    deleteIssueCall,
    editIssueCall,
    addMediaCall,
    updateElementImages,
    updateElementVideos,
    isViewOnly = true,
    isPublicAudit = false,
}) => {
    return (
        <AuditTable
            audit={audit}
            headerName={AuditItemTypeTitle.PINS}
            isViewOnly={isViewOnly}
            items={tidySelectedIssues}
            elementType={AnnotationType.ISSUE}
            updateElementImages={updateElementImages}
            updateElementVideos={updateElementVideos}
            onDelete={deleteIssueCall}
            onEdit={editIssueCall}
            onAddMedia={addMediaCall}
            dimensionHeader="Dimension"
            isPublicAudit={isPublicAudit}
        />
    );
};

AuditMapSelectedIssues.propTypes = {
    audit: PropTypes.object,
    tidySelectedIssues: PropTypes.array,
    deleteIssueCall: PropTypes.func,
    editIssueCall: PropTypes.func,
    addMediaCall: PropTypes.func,
    selectedIssues: PropTypes.array,
    updateElementImages: PropTypes.func,
    updateElementVideos: PropTypes.func,
    isViewOnly: PropTypes.bool,
    isPublicAudit: PropTypes.bool,
};
